
import Component from "vue-class-component";
import Vue from "vue";
import {
    MedicalCertificatesClient,
    AddMedicalCertificateRequest,
    MedicalCertificateActions,
    GetMedicalCertificateResponse, IAddMedicalCertificateRequest,
} from "@/api-client";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import FileUploader from "@/components/FileUploader.vue";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import MedicalCertificateUpsertForm from "@/features/medicalCertificates/components/MedicalCertificateUpsertForm.vue";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import {Location} from "vue-router";

interface Props {
    certificate: GetMedicalCertificateResponse;
    actions: MedicalCertificateActions;
    seafarerId: string;
}

@Component({
    components: {
        LabelOptional,
        SectionPageHeading,
        FileUploader,
        MedicalCertificateUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditMedicalCertificate>) {
        const props = to.meta!.props as Props;

        props.seafarerId = to.params.seafarerId

        Promise.all([
            new MedicalCertificatesClient().get(to.params.id),
            new MedicalCertificatesClient().availableActions(to.params.id)
        ]).then(values => {
            props.certificate = values[0];
            props.actions = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class EditMedicalCertificate extends Vue implements Props {
    @Prop({required: true})
    certificate!: GetMedicalCertificateResponse;

    @Prop({required: true})
    actions!: MedicalCertificateActions;

    @Prop({required: true})
    seafarerId!: string;

    @Prop({default: null})
    returnRoute!: Location | null;

    model!: IAddMedicalCertificateRequest;

    isCreated = false;

    async created() {
        this.model = {
            ...this.certificate,
            existingFiles: this.certificate.files,
            addedFiles: [],
            removedFiles: []
        }
        this.isCreated = true;
    }

    async submitCallback(model: AddMedicalCertificateRequest) {
        await new MedicalCertificatesClient()
            .edit(model, this.seafarerId, this.certificate.id);

        const route = this.returnRoute
            ? this.returnRoute
            : {path: `/seafarers/${this.seafarerId}/medical-certificates/${this.certificate.id}`};

        await this.$router.replace(route);
    }
}
